import { DetailsListLayoutMode, IColumn, Selection, Link, IDragDropContext, IDragDropEvents, IListProps, SelectionMode, Text, CommandBar, ICommandBarItemProps, IButtonProps, IPersonaSharedProps, Persona, PersonaSize, getTheme, SearchBox, Stack, Callout, DirectionalHint, IconButton, TagPicker, IBasePickerSuggestionsProps, IInputProps, ITag, TagItemSuggestion, FontIcon, TagItem, ISuggestionsProps, ISuggestionItemProps, ISuggestionModel, TextField, ITextFieldProps, Label, Overlay, ComboBox, Dropdown, PrimaryButton, DefaultButton, SpinButton, IContextualMenuProps, ShimmeredDetailsList, FocusZone, FocusZoneTabbableElements, FontWeights, Spinner, SpinnerSize, memoizeFunction, CommandBarButton, IDropdownOption, IStackComponent, ProgressIndicator, Pivot, PivotItem, Separator, TooltipHost } from "@fluentui/react"
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../../../../../../../app/Hooks"
import { getPage } from "../../../../../../../app/Pages"
import { setPage } from "../../../../../../layouts/Master/MasterLayoutSlice"
import { setTitle } from "../../../../../../common/NavHeader/NavHeaderSlice"
import { useSetInterval, useConst } from '@fluentui/react-hooks';
import { Table } from "../../../../../../common/Table/Table"
import { ApiMessage, CLIENT_PROFILE_LOGO_URL, getHeaders, getSession, PROFILE_LOGO_URL } from "../../../../../../../app/Api"
import { useId, useBoolean } from '@fluentui/react-hooks';

import { Message } from "../../../../../../common/Message/Message"
import { ShareBox } from "../../../../../../common/ShareBox/ShareBox"
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"
import { SessionExpiredDialog } from "../../../../../../common/SessionExpiredDialog/SessionExpiredDialog"
import React from "react"
import { dismissMessage, get, reset, resetItem, updateItem, updateStatus } from "./OrderTransactionDetailsPageSlice"
import { Popup } from "../../../../../../common/Popup/Popup"
import { FormType } from "../../../../../../forms/FormProps"
import { DynamicField } from "../../../../../../common/DynamicFields/DynamicFields"
import { DeleteCurrencyRequest, GetCurrencyRequest } from "../../../../../../../repository/Accountant/currency_pb"
import { CurrenciesForm } from "../../../../../../forms/Accountant/Currencies/CurrenciesForm"
import { CurrencyForm, OrderAction, OrderStatus, OrderTransactionStatus, OrderType } from "../../../../../../../app/Enums"
import { TextView } from "../../../../../../common/DataView/TextView"
import { ProfileView } from "../../../../../../common/DataView/ProfileView"
import { DeleteCurrencyPairRequest, GetCurrencyPairRequest, UpdateCurrencyPairActivityRequest } from "../../../../../../../repository/Trading/currency_pair_pb"
import { LinkView } from "../../../../../../common/DataView/LinkView"
import { currencyFormatter, printComponent, normalizeKey } from "../../../../../../../app/Helpers"
import { CurrencyPairsForm } from "../../../../../../forms/Trading/CurrencyPairs/CurrencyPairsForm"
import { GetOrderTransactionRequest, UpdateOrderTransactionStateRequest } from "../../../../../../../repository/Trading/orderTransaction_pb"
import { useReactToPrint } from "react-to-print"
import { TradesForm } from "../../../../../../forms/Trading/Trades/TradesForm"


const shimmeredDetailsListProps: IListProps = {
    renderedWindowsAhead: 0,
    renderedWindowsBehind: 0,
};


let req: GetOrderTransactionRequest;

let org: number = -1;

let getPromise: any;
let actionPromise: any;


const key = "trading/orderTransactions/details"
export const OrderTransactionDetailsPage: React.FunctionComponent = () => {

    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    let { id } = useParams();
    const { hash } = useLocation();
    const [selectedKey, setSelectedKey] = useState("0");
    const [tranStatus, setTranStatus] = useState<any>(undefined)

    const state: {
        isChangeStateLoading: boolean,
        message: ApiMessage | undefined,
        appTheme: string, isDarkModeEnabled: boolean,
        isLoading: boolean,
        item: any
    } = useAppSelector((state) => {
        return {
            isChangeStateLoading: state.orderTransactionDetailsPage.isChangeStateLoading,
            message: state.orderTransactionDetailsPage.message,
            appTheme: state.settings.appTheme, isDarkModeEnabled: state.settings.isDarkModeEnabled,
            isLoading: state.orderTransactionDetailsPage.isLoading,
            item: state.orderTransactionDetailsPage.item,

        }
    })
    const calloutTargetId = useId('callout-target');
    const labelId = useId('callout-label');
    const deleteActionConfirmationcalloutTargetId = useId('delete-action-callout-target');
    const activityActionConfirmationcalloutTargetId = useId('activity-action-callout-target');
    const ActionConfirmationLabelId = useId('action-callout-label');
    const shareCalloutLabelId = useId('share-callout-label');
    const shareTargetId = useId('share-callout-target');

    const [isActionConfirmationCalloutVisible, { toggle: toggleisActionConfirmationCalloutVisible }] = useBoolean(false);
    const [isShareCalloutVisible, { toggle: toggleisShareCalloutVisible }] = useBoolean(false);

    const [currentAction, setCurrenctAction] = useState(0)
    const ref = useRef<HTMLDivElement>(null);
    const reactToPrintContent = () => {
        return printComponent(ref.current?.cloneNode(true), true);
    };

    const handlePrint = useReactToPrint({});

    const getActionId = (action: number): string => {
        if (action == 1) {
            return deleteActionConfirmationcalloutTargetId;
        } else if (action == 2) {
            return activityActionConfirmationcalloutTargetId;
        } else {
            return ""
        }
    }


    useEffect(() => {
        req = new GetOrderTransactionRequest();
        var l = searchParams.get('org');
        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {

            }
        }
        const page = getPage(key)
        dispatch(setTitle(t(normalizeKey(page?.title))));
        dispatch(setPage(page));

        if (id) {
            req.setId(id)
            getPromise = dispatch(get({ body: req, headers: getHeaders() }))

        } else {
            navigate(-1)
        }


        return () => { //clean up
            getPromise?.abort();
            actionPromise?.abort();
            dispatch(reset());
        }
    }, [])



    const _selectionItems: ICommandBarItemProps[] = [
        {
            key: 'back',
            text: t('back'),
            title: t('back'),
            iconProps: { iconName: 'back' },
            disabled: state.isLoading,
            onClick: () => {
                navigate(-1)
            }
        },
        {
            key: 'edit',
            text: t("edit"),
            title: t("edit"),
            iconProps: { iconName: 'EditSolid12' },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(108)
                }
            }
        },
        {
            key: 'status',
            text: t("updateOrderTranStatus"),
            iconProps: { id: activityActionConfirmationcalloutTargetId, iconName: "StatusCircleInner", styles: { root: { fontWeight: "bold" } } },
            title: t("updateOrderTranStatus"),
            commandBarButtonAs: (e) => {
                return <CommandBarButton {...(e as IButtonProps)} iconProps={state.isChangeStateLoading && currentAction == 2 ? undefined : e.iconProps} text={state.isChangeStateLoading && currentAction == 2 ? undefined : e.text}  >
                    <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isChangeStateLoading && currentAction == 2 ? "block" : "none") } }} />
                </CommandBarButton>;
            },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(2)
                    toggleisActionConfirmationCalloutVisible()
                }
            }
        },
        {
            key: 'refresh',
            text: t('refresh'),
            title: t('refresh'),
            iconProps: { iconName: 'refresh' },
            disabled: state.isLoading,
            onClick: () => {
                dispatch(resetItem())
                getPromise = dispatch(get({ body: req, headers: getHeaders() }))
            }
        },


        {
            key: 'logs',
            text: t("logs"),
            iconProps: { iconName: "PageList", styles: { root: { fontWeight: "bold" } } },
            title: t("logs"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    navigate("/logs?resourceId=" + state.item?.id + ((org == -1) ? "" : "&org=" + org));
                }
            }
        },
        {
            key: 'share',
            text: t("share"),
            title: t("share"),
            iconProps: { id: shareTargetId, iconName: 'Share', styles: { root: { fontWeight: "bold" } } },
            onClick: () => {
                toggleisShareCalloutVisible()
            },

        },
        {
            key: 'print',
            text: t("print"),
            iconProps: { iconName: "Print", styles: { root: { fontWeight: "bold" } } },
            title: t("print"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    handlePrint(reactToPrintContent);
                }
            }
        },
    ];

    const _selectionItemsNoStatus: ICommandBarItemProps[] = [
        {
            key: 'back',
            text: t('back'),
            title: t('back'),
            iconProps: { iconName: 'back' },
            disabled: state.isLoading,
            onClick: () => {
                navigate(-1)
            }
        },
        {
            key: 'edit',
            text: t("edit"),
            title: t("edit"),
            iconProps: { iconName: 'EditSolid12' },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(108)
                }
            }
        },

        {
            key: 'refresh',
            text: t('refresh'),
            title: t('refresh'),
            iconProps: { iconName: 'refresh' },
            disabled: state.isLoading,
            onClick: () => {
                dispatch(resetItem())
                getPromise = dispatch(get({ body: req, headers: getHeaders() }))
            }
        },


        {
            key: 'logs',
            text: t("logs"),
            iconProps: { iconName: "PageList", styles: { root: { fontWeight: "bold" } } },
            title: t("logs"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    navigate("/logs?resourceId=" + state.item?.id + ((org == -1) ? "" : "&org=" + org));
                }
            }
        },
        {
            key: 'share',
            text: t("share"),
            title: t("share"),
            iconProps: { id: shareTargetId, iconName: 'Share', styles: { root: { fontWeight: "bold" } } },
            onClick: () => {
                toggleisShareCalloutVisible()
            },

        },
        {
            key: 'print',
            text: t("print"),
            iconProps: { iconName: "Print", styles: { root: { fontWeight: "bold" } } },
            title: t("print"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    handlePrint(reactToPrintContent);
                }
            }
        },
    ];


    return (
        <Stack >
            {state.message != undefined ? (state.message.data != 401) ? <Message
                body={state.message.body}
                title={state.message.title}
                data={state.message.data}
                onDismiss={() => { dispatch(dismissMessage()) }}
                type={state.message.type}
            /> :
                <SessionExpiredDialog />
                : null
            }


            <Popup isOpen={(currentAction == 108)} title={t("editTransaction")} onDismiss={() => { setCurrenctAction(0) }} >

                <TradesForm childrenGap={10} maxWidth={280} type={FormType.EDIT} renderObject={state.item} onSuccess={(e) => {
                    setCurrenctAction(0)
                    dispatch(updateItem(e))
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>
            {isShareCalloutVisible ? (
                <Callout
                    ariaLabelledBy={shareCalloutLabelId}
                    target={`#${shareTargetId}`}
                    onDismiss={toggleisShareCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <ShareBox onDismiss={toggleisShareCalloutVisible} title={t("shareOrderTransaction")} value={`https://${window.location.host}/orderTransactions/${state.item?.id}` + ((org == -1) ? "" : "?org=" + org)}></ShareBox>
                </Callout>
            ) : null}



            {isActionConfirmationCalloutVisible ? (
                <Callout
                    ariaLabelledBy={ActionConfirmationLabelId}
                    target={`#${getActionId(currentAction)}`}
                    onDismiss={toggleisActionConfirmationCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <Stack tokens={{ padding: '20px 24px ' }}>
                        <Text block variant="xLarge" styles={{ root: { marginBottom: 12 } }}>
                            {(currentAction == 2 ? t("updateOrderTranStatus") : "")}
                        </Text>


                        <ComboBox
                            label={t("status")}
                            required
                            allowFreeform={true}
                            autoComplete={'on'}
                            disabled={state.isChangeStateLoading}
                            options={[
                                { key: OrderTransactionStatus.PENDING, text: t("pending") },
                                { key: OrderTransactionStatus.PROCESSING, text: t("processing") },

                                { key: OrderTransactionStatus.REJECTED, text: t("rejected") },
                                { key: OrderTransactionStatus.SETTLED, text: t("settled") },
                                { key: OrderTransactionStatus.EXPIRED, text: t("expired") },
                                { key: OrderTransactionStatus.FAILED, text: t("failed") },
                                { key: OrderTransactionStatus.CANCELLED, text: t("cancelled") }
                            ].filter(e => e.key != state.item?.statusId)}
                            selectedKey={tranStatus?.key}
                            onChange={(e, o) => {
                                setTranStatus({ key: o?.key, text: o?.text })
                            }} />


                        {/* This FocusZone allows the user to go between buttons with the arrow keys.
              It's not related to or required for FocusTrapCallout's built-in focus trapping. */}
                        <FocusZone handleTabKey={FocusZoneTabbableElements.all} isCircularNavigation>
                            <Stack reversed tokens={{ childrenGap: 8, padding: "20px 0px 0px 0px" }} horizontal>
                                <DefaultButton autoFocus onClick={toggleisActionConfirmationCalloutVisible}>{t("cancel")}</DefaultButton>

                                <PrimaryButton onClick={() => {
                                    toggleisActionConfirmationCalloutVisible()
                                    if (state.item) {
                                        if (currentAction == 2) {
                                            if (tranStatus) {
                                                let req = new UpdateOrderTransactionStateRequest();
                                                req.setId(state.item?.id)

                                                req.setStatus(tranStatus.key)

                                                actionPromise?.abort();
                                                actionPromise = dispatch(updateStatus({ body: req, headers: getHeaders(), metadata: getSession() }))
                                                actionPromise.unwrap().then((e: any) => {
                                                    setTranStatus(undefined)
                                                })

                                            }

                                        }
                                    }
                                    setTranStatus(undefined)

                                }} text={(currentAction == 2 ? t("change") : "")}  >

                                </PrimaryButton>
                            </Stack>
                        </FocusZone>
                    </Stack>
                </Callout>
            ) : null}


            {state.isLoading ? <ProgressIndicator /> :

                !state.item ? null :
                    <div ref={ref}>
                        <CommandBar
                            items={state.item.statusId == undefined || state.item.statusId == OrderTransactionStatus.PENDING ||
                                state.item.statusId == OrderTransactionStatus.NEW || state.item.statusId == OrderTransactionStatus.PROCESSING ? _selectionItems : _selectionItemsNoStatus}

                        //id={actionConfirmationcalloutTargetId}

                        />
                        <Stack tokens={{ childrenGap: 10, padding: "0px 33% 10px 3%" }}>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>

                                <TextView label={t("id")} value={state.item?.id} />


                                <TextView label={t("createdDate")} value={state.item?.createdDate} />

                                {state.item?.addedBy ? <ProfileView label={t("addedBy")} value={state.item?.addedBy == "" ? state.item?.addedById : state.item?.addedBy}
                                    url={"/management/users/" + state.item?.addedById + ((org == -1) ? "" : "?org=" + org)}
                                    text={state.item?.addedBy == "" ? state.item?.addedById : state.item?.addedBy}
                                    imageUrl={PROFILE_LOGO_URL + "/" + getSession()?.organization?.id + "/" + state.item?.addedById + "/profile.jpg"}
                                    size={PersonaSize.size40} />

                                    : undefined}

                            </Stack>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>

                                <TextView styles={{ root: { color: state.item?.currencyId == state.item?.currencyPairQuoteCurrencyId ? "#008000" : "#FF0000" } }} label={t("transactionTitle")} value={state.item?.currencyId == state.item?.currencyPairQuoteCurrencyId ? t("buy") : t("sell")} />
                                <TextView label={t("status")} value={[{ key: OrderTransactionStatus.NEW, text: t("new") },
                                { key: OrderTransactionStatus.EXPIRED, text: t("expired") },
                                { key: OrderTransactionStatus.FAILED, text: t("failed") }, { key: OrderTransactionStatus.CANCELLED, text: t("cancelled") },
                                { key: OrderTransactionStatus.PENDING, text: t("pending") }, { key: OrderTransactionStatus.PROCESSING, text: t("processing") }
                                    , { key: OrderTransactionStatus.REJECTED, text: t("rejected") }
                                    , { key: OrderTransactionStatus.SETTLED, text: t("settled") }
                                ].filter(e => e.key == state.item?.statusId).at(0)?.text ?? t("new")} />

                            </Stack>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                                <ProfileView label={t("pair")} value={state.item?.currencyPairName}
                                    url={"/currency-pairs/" + state.item?.currencyPairId + ((org == -1) ? "" : "?org=" + org)}
                                    text={state.item?.currencyPairName}
                                    secondaryText={(state.item?.currencyPairBaseCurrencyCode == "" ? state.item?.currencyPairBaseCurrencyId : state.item?.currencyPairBaseCurrencyCode) + "-" + (state.item?.currencyPairQuoteCurrencyCode == "" ? state.item?.currencyPairQuoteCurrencyId : state.item?.currencyPairQuoteCurrencyCode)}
                                    imageInitials={state.item?.currencyPairBaseCurrencySymbol + "/" + state.item?.currencyPairQuoteCurrencySymbol}
                                    size={PersonaSize.size40}

                                />
                                <TextView label={t("price")} value={currencyFormatter(state.item?.itemPrice, { significantDigits: state.item?.currencyPairQuoteCurrencyDecimalPlaces ?? 9, symbol: state.item?.currencyPairQuoteCurrencySymbol })} />

                                <TextView label={t("amount")} value={currencyFormatter(state.item?.itemQuantity, { significantDigits: state.item?.currencyPairBaseCurrencyDecimalPlaces ?? 9, symbol: state.item?.currencyPairBaseCurrencySymbol })} />

                                <TextView label={t("total")} value={currencyFormatter(state.item?.itemSubTotal, { significantDigits: state.item?.currencyPairQuoteCurrencyDecimalPlaces ?? 9, symbol: state.item?.currencyPairQuoteCurrencySymbol })} />


                            </Stack>

                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                                <LinkView label={t("buyOrder")} value={state.item?.buyOrder}
                                    url={"/orders/" + state.item?.buyOrder + ((org == -1) ? "" : "?org=" + org)} />

                                <LinkView label={t("buyTransaction")} value={state.item?.buyTransactionId}
                                    url={"/account-transactions/" + state.item?.buyTransactionInternalId + ((org == -1) ? "" : "?org=" + org)} />



                                <LinkView label={t("sellOrder")} value={state.item?.sellOrder}
                                    url={"/orders/" + state.item?.sellOrder + ((org == -1) ? "" : "?org=" + org)} />
                                <LinkView label={t("sellTransaction")} value={state.item?.sellTransactionId}
                                    url={"/account-transactions/" + state.item?.sellTransactionInternalId + ((org == -1) ? "" : "?org=" + org)} />


                            </Stack>

                            <Stack horizontal tokens={{ childrenGap: 10 }}>

                                <LinkView label={t("from")} value={state.item?.fromAccountName == "" ? state.item?.fromAccountId : state.item?.fromAccountName}
                                    url={"/accounts/" + state.item?.fromAccountInternalId + ((org == -1) ? "" : "?org=" + org)} />

                                <LinkView label={t("to")} value={state.item?.toAccountName == "" ? state.item?.toAccountId : state.item?.toAccountName}
                                    url={"/accounts/" + state.item?.toAccountInternalId + ((org == -1) ? "" : "?org=" + org)} />



                            </Stack>


                            <Stack horizontal tokens={{ childrenGap: 10 }}>


                                {state.item?.clientId ? <ProfileView label={t("client")} value={state.item?.clientName == "" ? state.item?.clientId : state.item?.clientName}
                                    url={"/customers/users/" + state.item?.clientId + ((org == -1) ? "" : "?org=" + org)}
                                    text={state.item?.clientName == "" ? state.item?.clientId : state.item?.clientName}
                                    imageUrl={CLIENT_PROFILE_LOGO_URL + "/" + getSession()?.organization?.id + "/" + state.item?.clientId + "/profile.jpg"}

                                    size={PersonaSize.size40} /> : undefined}





                            </Stack>

                            <TextView label={t("cancelationReason")} value={state.item?.attachments?.filter((e: DynamicField) => e.key == "p2p_fail_reason")?.at(0)?.value} />

                            <Separator alignContent="start"><b>{t("otherInfo")}</b></Separator>

                            {state.item?.extraFields.map((e: DynamicField, index: number) => {
                                return <Stack key={e.key}>
                                    <TextView label={e.label ?? ""} value={e?.value} />

                                </Stack>
                            })}
                        </Stack>
                    </div>

            }


        </Stack>



    );
}




